import React, { FC } from 'react';

import { QueryGetLeaderboardForUserArgs } from 'api';
import { Queries } from 'components';

import Widget from './Widget';

interface IProps {
  variables: QueryGetLeaderboardForUserArgs;
}

const Query: FC<IProps> = ({ variables }) => (
  <Queries.GetUserLeaderboards loader="widget" variables={variables}>
    {data => {
      const { leaderboard_configs } = data;
      if (!leaderboard_configs.length) {
        return null;
      }

      return <Widget configs={leaderboard_configs} variables={variables} />;
    }}
  </Queries.GetUserLeaderboards>
);

export default Query;
